"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPlayer = void 0;
const gotti_1 = require("gotti");
const types_1 = require("../../Shared/types");
const Component_1 = require("../Systems/Input/Component");
const Component_2 = require("../Systems/PlayerMovement/Component");
const Position_1 = require("../../Shared/Components/Position");
const Component_3 = require("../Systems/PlayerAnimation/Component");
const Component_4 = require("../Systems/PlayerAction/Component");
const Component_5 = require("../Systems/Inventory/Component");
const Component_6 = require("../Systems/GameState/Component");
const Component_7 = require("../Systems/BugCatch/Component");
class ClientPlayer extends gotti_1.Entity {
    constructor() {
        super(1, types_1.EntityTypes.ClientPlayer);
        this.action = 'idle';
        this.playerInput = {
            action: false,
            hotkeyIndex: -1,
            mouseX: 0,
            mouseY: 0,
            mouseDown: false,
            aimAngle: 0,
            moveUp: false,
            moveDown: false,
            moveLeft: false,
            moveRight: false,
            inventory: false,
            grab: false,
            sprint: false,
            cancel: false,
            escape: false,
        };
    }
    get gameState() {
        if (!this.gameStateComponent)
            throw new Error(`Dont try to get the gameState from the client before its initialized.`);
        return this.gameStateComponent.data;
    }
    initialize(data) {
        this.gameStateComponent = new Component_6.GameStateComponent(data);
        this.addComponent(this.gameStateComponent);
        this.addComponent(new Component_1.InputComponent(this.playerInput));
        //console.error('init wit pos was', {...data.position })
        this.addComponent(new Position_1.Position(data.position.x, data.position.y));
        this.addComponent(new Component_2.PlayerMovementComponent(types_1.GameValues.PlayerSpeed));
        this.addComponent(new Component_3.PlayerAnimationComponent('player'));
        this.addComponent(new Component_4.PlayerActionComponent());
        this.addComponent(new Component_5.InventoryComponent());
        this.addComponent(new Component_7.BugCatchComponent());
    }
}
exports.ClientPlayer = ClientPlayer;
//# sourceMappingURL=module.js.map